import VisualizationsHeader from './VisualizationsHeader';
import './VisualizationsHeader.scss';

export default VisualizationsHeader;
